import { get } from 'lodash-es'

export const bussinessRoutes: Array<any> = [
  {
    path: '/template',
    name: 'Template',
    component: () => import('@/layouts/router.vue'),
    meta: { permission: false, title: '模版页面示例', showHeader: true, showSide: true },
    redirect: '/template/list',
    children: [
      {
        path: 'list',
        name: 'TemplateList',
        component: () => import('@/pages/template/list.vue'),
        meta: { permission: false, title: '列表页面', showHeader: true, showSide: true }
      },
      {
        path: 'add-page',
        name: 'TemplateAdd',
        component: () => import('@/pages/template/add.vue'),
        meta: { permission: false, title: '新增页面', showHeader: true, showSide: true }
      },
      {
        path: 'detail-page',
        name: 'TemplateDetail',
        component: () => import('@/pages/template/detail.vue'),
        meta: { permission: false, title: '详情页面', showHeader: true, showSide: true }
      }
    ]
  },

  {
    path: '/equipment',
    name: 'Equipment',
    component: () => import('@/layouts/router.vue'),
    meta: { permission: false, title: '装备列表', showHeader: true, showSide: true },
    redirect: '/equipment/index',
    children: [
      {
        path: 'index',
        name: 'EquipmentList',
        component: () => import('@/pages/Equipment/index.vue'),
        meta: { permission: false, title: '装备列表', showHeader: true, showSide: true }
      },
      {
        path: 'detail',
        name: 'EquipmentDetail',
        component: () => import('@/pages/Equipment/detail.vue'),
        meta: { permission: false, title: '装备详情', showHeader: true, showSide: true }
      }
    ]
  },
  {
    path: '/category',
    name: 'Category',
    component: () => import('@/layouts/router.vue'),
    meta: { permission: false, title: '分类', showHeader: true, showSide: true },
    redirect: '/category/index',
    children: [
      {
        path: 'index',
        name: 'CategoryIndex',
        component: () => import('@/pages/Category/index.vue'),
        meta: { permission: false, title: '分类', showHeader: true, showSide: true }
      }
    ]
  }

]

// 用户反馈
export const feedbackRoutes = [
  {
    path: '/user-feedback',
    name: 'UserFeedback',
    component: () => import('@/layouts/router.vue'),
    meta: { permission: false, title: '用户反馈', showHeader: true, showSide: true },
    redirect: '/user-feedback/submit',
    children: [
      {
        path: 'submit',
        name: 'UserFeedbackSubmit',
        component: () => import('@/pages/UserFeedback/index.vue'),
        meta: { permission: false, title: '提交反馈', showHeader: true, showSide: true }
      },
      {
        path: 'list',
        name: 'UserFeedbackList',
        component: () => import('@/pages/UserFeedback/list.vue'),
        meta: { permission: false, title: '我的反馈', showHeader: true, showSide: true }
      },
      {
        path: 'detail',
        name: 'UserFeedbackDetail',
        component: () => import('@/pages/UserFeedback/detail.vue'),
        meta: { permission: false, title: '反馈详情', showHeader: true, showSide: true, hidden: true }
      }
    ]
  }
]



export const specialFeatureRoutes = [
  {
    path: '/special-feature',
    name: 'SpecialFeature',
    component: () => import('@/layouts/router.vue'),
    meta: { permission: false, title: '特色专区', showHeader: true, showSide: true },
    redirect: '/special-feature/index',
    children: [
      {
        path: 'index',
        name: 'SpecialFeatureIndex',
        component: () => import('@/pages/SpecialFeature/index.vue'),
        meta: { permission: false, title: '特色专区', showHeader: true, showSide: true }
      },
      {
        path: 'featureItem',
        name: 'FeatureFeatureItem',
        component: () => import('@/pages/SpecialFeature/featureItem.vue'),
               meta: { permission: false, title: '特色专区', showHeader: true, showSide: true } 
      }
    ]
  }
]

export const useBussinessRoutes = () => {

  const routes = [...bussinessRoutes]
  // 处理路由的数据结构，以达到aside侧边栏菜单组件的格式
  const handleRoutes = routes.map((module, index) => {
    const extra = {
      name: get(module, 'meta.title', '未命名菜单'),
      hidden: 1,// 0为隐藏，1为显示
      routerPath: get(module, 'path', ''),
      children: get(module, 'children', []).map((child: any) => {
        return {
          name: get(child, 'meta.title', '未命名菜单'),
          hidden: 1,// 0为隐藏，1为显示
          routerPath: module.path + '/' + get(child, 'path', ''),
        }
      })
    }
    return extra
  })

  return handleRoutes
}


